const supportFaqData = [
  {
    category: 'Cuenta y Acceso',
    items: [
      {
        key: 'cuenta-1',
        question: '¿Qué es Sthenus?',
        answer:
          'Sthenus es una aplicación de fitness que te ayuda a alcanzar tus objetivos mediante rutinas de entrenamiento personalizadas, seguimiento de progreso y acceso a una amplia variedad de ejercicios para diferentes niveles de experiencia.',
      },
      {
        key: 'cuenta-2',
        question: '¿Necesito crear una cuenta para utilizar Sthenus?',
        answer:
          'Sí. Es necesario crear una cuenta para guardar tu progreso, acceder a rutinas personalizadas y sincronizar tu información entre dispositivos.',
      },
      {
        key: 'cuenta-3',
        question: '¿Puedo utilizar Sthenus en más de un dispositivo?',
        answer:
          'Sí, puedes acceder a tu cuenta desde distintos dispositivos compatibles utilizando las mismas credenciales.',
      },
      {
        key: 'cuenta-4',
        question: 'Olvidé mi contraseña. ¿Qué puedo hacer?',
        answer:
          'Puedes utilizar la opción "Recuperar contraseña" desde la pantalla de inicio de sesión y seguir las instrucciones enviadas a tu correo electrónico.',
      },
      {
        key: 'cuenta-5',
        question: '¿Puedo cambiar mis datos personales?',
        answer:
          'Sí. Puedes actualizar tu información desde la sección "Mi Perfil" dentro de la aplicación.',
      },
    ],
  },
  {
    category: 'Rutinas y Entrenamientos',
    items: [
      {
        key: 'rutinas-1',
        question: '¿Sthenus es para principiantes o solo para personas con experiencia?',
        answer:
          'Sthenus está diseñado para todos los niveles, desde principiantes hasta usuarios avanzados.',
      },
      {
        key: 'rutinas-2',
        question: '¿Cómo se generan mis rutinas personalizadas?',
        answer:
          'Las rutinas se adaptan con base en la información que proporcionas, como objetivos, experiencia, frecuencia de entrenamiento y preferencias.',
      },
      {
        key: 'rutinas-3',
        question: '¿Puedo cambiar mis objetivos de entrenamiento?',
        answer:
          'Sí. Puedes modificar tus objetivos en cualquier momento y la aplicación ajustará las recomendaciones futuras.',
      },
      {
        key: 'rutinas-4',
        question: '¿Necesito equipo de gimnasio para usar Sthenus?',
        answer:
          'Dependerá de la rutina seleccionada. Algunas rutinas requieren equipo de gimnasio y otras pueden realizarse en casa con poco o ningún equipamiento.',
      },
      {
        key: 'rutinas-5',
        question: '¿Puedo registrar mi progreso?',
        answer:
          'Sí. Sthenus permite registrar entrenamientos, tiempo de ejercicio, peso utilizado y otros indicadores de progreso.',
      },
      {
        key: 'rutinas-6',
        question: '¿Qué sucede si no termino una rutina?',
        answer:
          'Podrás retomarla posteriormente o iniciar una nueva sesión cuando lo desees.',
      },
    ],
  },
  {
    category: 'Suscripciones y Pagos',
    items: [
      {
        key: 'suscripciones-1',
        question: '¿Sthenus es gratuita?',
        answer:
          'La descarga de la aplicación puede ser gratuita, pero algunas funciones y contenido requieren una suscripción activa.',
      },
      {
        key: 'suscripciones-2',
        question: '¿Qué tipos de suscripción existen?',
        answer: 'Actualmente ofrecemos planes mensuales y anuales.',
      },
      /*{
        key: 'suscripciones-3',
        question: '¿La suscripción se renueva automáticamente?',
        answer:
          'No. Las suscripciones no se renuevan automáticamente hasta que sean canceladas.',
      },*/
      {
        key: 'suscripciones-4',
        question: '¿Cómo puedo cancelar mi suscripción?',
        answer:
          'Puedes cancelarla desde tu cuenta de App Store, Google Play o desde el método de contratación correspondiente.',
      },
      {
        key: 'suscripciones-5',
        question: '¿Perderé acceso inmediatamente al cancelar?',
        answer:
          'No. Mantendrás acceso a los beneficios de tu suscripción hasta el final del periodo ya pagado.',
      },
      {
        key: 'suscripciones-6',
        question: '¿Puedo solicitar un reembolso?',
        answer:
          'Las compras realizadas mediante App Store o Google Play están sujetas a las políticas de reembolso de cada plataforma.',
      },
    ],
  },
  {
    category: 'Salud y Seguridad',
    items: [
      {
        key: 'salud-1',
        question: '¿Sthenus ofrece asesoría médica?',
        answer:
          'No. La aplicación proporciona información y programas de entrenamiento con fines educativos y de acondicionamiento físico, pero no sustituye el consejo médico profesional.',
      },
      {
        key: 'salud-2',
        question: '¿Debo consultar a un médico antes de comenzar?',
        answer:
          'Sí. Recomendamos consultar con un profesional de la salud antes de iniciar cualquier programa de ejercicio, especialmente si tienes condiciones médicas preexistentes.',
      },
      {
        key: 'salud-3',
        question: '¿Sthenus garantiza resultados?',
        answer:
          'No. Los resultados dependen de múltiples factores individuales como constancia, alimentación, descanso, genética y condición física inicial.',
      },
      {
        key: 'salud-4',
        question: '¿Qué debo hacer si siento dolor o malestar durante un entrenamiento?',
        answer:
          'Debes detener inmediatamente la actividad y consultar a un profesional de la salud si los síntomas persisten.',
      },
    ],
  },
  {
    category: 'Privacidad y Datos Personales',
    items: [
      {
        key: 'privacidad-1',
        question: '¿Qué información recopila Sthenus?',
        answer:
          'Recopilamos información necesaria para crear tu cuenta, personalizar tu experiencia y registrar tu progreso dentro de la aplicación.',
      },
      {
        key: 'privacidad-2',
        question: '¿Mis datos personales están protegidos?',
        answer:
          'Sí. Implementamos medidas de seguridad para proteger la información de nuestros usuarios.',
      },
      {
        key: 'privacidad-3',
        question: '¿Sthenus vende mis datos personales?',
        answer: 'No. Sthenus no vende información personal a terceros.',
      },
      {
        key: 'privacidad-4',
        question: '¿Cómo puedo solicitar la eliminación de mi cuenta?',
        answer:
          'Puedes solicitar la eliminación de tu cuenta y datos personales desde la aplicación o contactando al equipo de soporte.',
      },
      {
        key: 'privacidad-5',
        question: '¿Qué sucede con mis datos si elimino mi cuenta?',
        answer:
          'Tus datos serán eliminados o anonimizados de acuerdo con nuestras obligaciones legales y nuestra Política de Privacidad.',
      },
    ],
  },
  {
    category: 'Soporte Técnico',
    items: [
      {
        key: 'soporte-1',
        question: 'La aplicación no funciona correctamente. ¿Qué puedo hacer?',
        answer:
          'Verifica que tengas instalada la última versión de Sthenus y reinicia la aplicación. Si el problema continúa, contacta a soporte técnico.',
      },
      {
        key: 'soporte-2',
        question: '¿Cómo puedo reportar un error?',
        answer:
          'Puedes reportar incidencias mediante la sección de soporte dentro de la aplicación o escribiendo a nuestro correo de atención.',
      },
      {
        key: 'soporte-3',
        question: '¿Cómo puedo contactar al equipo de soporte?',
        answer:
          'Puedes comunicarte con nosotros a través del correo electrónico de soporte indicado en la aplicación y en nuestro sitio web oficial.',
      },
    ],
  },
];

export default supportFaqData;
